import { render, staticRenderFns } from "./NominaTrabajadores.vue?vue&type=template&id=848627d4&"
import script from "./NominaTrabajadores.vue?vue&type=script&lang=js&"
export * from "./NominaTrabajadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports